<div class="container-fluid widget-wrapper">
  <div class="row widget-header" #widgetHeader [ngClass]="{ sticky: isTop }">
    <div class="col-lg-12">
      <h2>
        <span>More Apps by the Developer</span><span class="app-title">&nbsp;{{ appName | appPrefix:"of" }}</span>
        <ng-container *ngTemplateOutlet="swiperControls"></ng-container>
      </h2>
    </div>
  </div>
  <div class="row widget-body">
    <div class="col-lg-12">
      <app-developer-apps [developerName]="data?.publisherOverview?.name"
                          [appId]="data?.appOverview?.appId"
                          [appStore]="os" [device]="device" [region]="region">
      </app-developer-apps>
    </div>
  </div>
</div>
